<template>
	<div class="client-container">
		<div :style="{ overflow: 'hidden' }">
			<bread-crumb :style="{ float: 'left' }" />
			<a-button
				type="primary"
				shape="round"
				icon="plus"
				:style="{ float: 'right', marginTop: '19px' }"
				@click="addNew"
			>
				新增管理员
			</a-button>

			<a-form :form="pageSearchForm">
				<a-form-item :style="{ float: 'right' }">
					<a-select
						class="activity-config-search"
						v-if="searchArgs.platform_type !== 'pl'"
						:style="{
							marginTop: '19px',
							width: '300px',
							marginRight: '20px',
						}"
						:loading="loadingSearchCompany"
						v-decorator="[
							'company_id',
							{
								initialValue: searchArgs.company_id,
							},
						]"
						placeholder="请选择企业"
						@change="handleChangeCompany"
					>
						<a-select-option
							v-for="item in searchArgs.company_list"
							:title="
								item.team_name ? item.team_name : item.companyInfo.qichacha_name
							"
							:key="item.id"
						>
							{{
								item.team_name ? item.team_name : item.companyInfo.qichacha_name
							}}
						</a-select-option>
					</a-select>
				</a-form-item>

				<a-form-item :style="{ float: 'right' }">
					<a-select
						class="activity-config-search"
						:style="{
							marginTop: '19px',
							width: '120px',
							marginRight: '20px',
						}"
						v-decorator="[
							'platform_type',
							{
								initialValue: searchArgs.platform_type,
							},
						]"
						:loading="loadingSearchCompany"
						placeholder="请选择平台"
						@change="handleChangePlatform"
					>
						<a-select-option key="pl" value="pl">平台端</a-select-option>
						<a-select-option key="cp" value="cp">药企端</a-select-option>
						<a-select-option key="sp" value="sp">服务商端</a-select-option>
					</a-select>
				</a-form-item>
			</a-form>
		</div>
		<div class="global-table-container">
			<a-table
				:pagination="showPagination"
				:columns="tableColumns"
				:dataSource="tableDataList"
				:rowSelection="rowSelection"
				:scroll="{ x: 1100, y: 450 }"
			>
				<div slot="admin_flag" slot-scope="text, record">
					<a-icon
						v-if="record.is_admin == 1"
						type="check-circle"
						style="color:#7cb305;"
					/>
					<a-icon
						v-if="record.is_admin != 1"
						type="close-circle"
						style="color:#8c8c8c;"
					/>
				</div>
				<div slot="action" slot-scope="text, record">
					<div
						v-if="
							record.is_admin == 1 &&
								searchArgs.platform_type == 'pl' &&
								uid != record.id
						"
					>
						<a-tag class="action-btn" color="green">主管理</a-tag>
						<a-button
							class="action-btn"
							v-if="!record.status"
							type="primary"
							shape="round"
							size="small"
							@click.stop="handleSetStatus(record, 1)"
						>
							启用
						</a-button>
						<a-button
							class="action-btn"
							v-if="record.status"
							type="dashed"
							shape="round"
							size="small"
							@click.stop="handleSetStatus(record, 0)"
						>
							禁用
						</a-button>
					</div>
					<div
						v-if="
							record.is_admin != 1 ||
								uid == record.id ||
								searchArgs.platform_type != 'pl'
						"
					>
						<a-tag class="action-btn" color="green" v-if="record.is_admin == 1"
							>主管理</a-tag
						>
						<a-tag class="action-btn" color="blue" v-if="uid == record.id"
							>自己</a-tag
						>
						<a-button
							class="action-btn"
							v-if="!record.status"
							type="primary"
							shape="round"
							size="small"
							@click.stop="handleSetStatus(record, 1)"
						>
							启用
						</a-button>
						<a-button
							class="action-btn"
							v-if="record.status"
							type="dashed"
							shape="round"
							size="small"
							@click.stop="handleSetStatus(record, 0)"
						>
							禁用
						</a-button>
						<a-button
							class="action-btn"
							size="small"
							type="primary"
							shape="circle"
							icon="eye"
							title="查看管理员详情"
						></a-button>
						<a-button
							class="action-btn"
							size="small"
							title="修改管理员"
							type="primary"
							shape="circle"
							icon="edit"
							@click.stop="handleEdit(record)"
						></a-button>
						<!-- 
            <a-button
            class="action-btn"
              size="small"
              title="删除管理员"
              type="danger"
              shape="circle"
              icon="delete"
            ></a-button>
            -->
						<a-button
							class="action-btn"
							type="primary"
							shape="round"
							size="small"
							@click.stop="bindAuthGroup(record)"
						>
							角色
						</a-button>
						&nbsp;
						<a-button
							v-if="searchArgs.platform_type != 'pl'"
							class="action-btn"
							type="primary"
							shape="round"
							size="small"
							@click.stop="bindArea(record)"
						>
							大区
						</a-button>
					</div>
				</div>
			</a-table>
		</div>
	</div>
</template>
<script>
import updatePanel from "@/views/System/manager/update.vue";
import authGroupPanel from "@/views/System/manager/authGroup.vue";
import areaPanel from "@/views/System/manager/area.vue";

var num = 0;
var pageContext;
export default {
	name: "ManagerMgList",
	data() {
		return {
			uid: localStorage.getItem("uid"),
			showPagination: false,
			pageSearchForm: this.$form.createForm(this),
			loadingSearchCompany: false,
			//检索参数
			company_label: "药企",
			searchArgs: {
				platform_type: "pl", //选择平台
				company_id: "", //选择企业
				company_list: [], //当前选择企业列表
			},
			tableColumns: [],
			tableDataList: [],
			rowSelection: {
				fixed: true,
				onChange: (selectedRowKeys, selectedRows) => {
					console.log(selectedRowKeys);
				},
			},
		};
	},
	mounted() {
		pageContext = this;
		pageContext.initColumns();
		pageContext.handleChangePlatform("pl");
	},
	methods: {
		initColumns() {
			pageContext.tableColumns = [
				{
					title: "编号",
					dataIndex: "id",
					key: "id",
					width: "80px",
				},
				{
					title: "主管理",
					key: "is_admin",
					width: "80px",
					scopedSlots: { customRender: "admin_flag" },
				},
				{
					title: "用户名",
					dataIndex: "username",
					key: "username",
				},
				{
					title: "昵称",
					dataIndex: "nickname",
					key: "nickname",
				},
				{
					title: "姓名",
					dataIndex: "real_name",
					key: "real_name",
				},
				{
					title: "手机号",
					dataIndex: "phone",
					key: "phone",
					width: "150px",
				},
				{
					title: "操作",
					key: "operation",
					fixed: "right",
					width: 350,
					scopedSlots: { customRender: "action" },
				},
			];
		},
		async handleChangePlatform(value) {
			pageContext.searchArgs.platform_type = value;

			pageContext.searchArgs.company_list = [];
			pageContext.searchArgs.company_id = "";
			pageContext.pageSearchForm.setFieldsValue({
				company_id: pageContext.searchArgs.company_id,
			});
			pageContext.tableDataList = [];
			//平台直接加载管理员数据
			if (value === "pl") {
				pageContext.company_label = "";
				pageContext.refreshDataList();
			}
			//加载企业列表
			else {
				pageContext.company_label = value === "cp" ? "药企" : "服务商";
				pageContext.loadingSearchCompany = true;
				pageContext.pageSearchForm.setFieldsValue({
					company_id: "",
				});
				pageContext.$http
					.post(
						value === "cp"
							? "/company/getCompanyList"
							: "/ServiceProvider/getCompanyList",
						{
							sign_flag: 1,
							status: 1,
						}
					)
					.then(function(response) {
						if (
							response.data.status === 1 &&
							response.data.data.data_list.length > 0
						) {
							pageContext.$message.success(
								"请选择：" + pageContext.company_label
							);
							pageContext.searchArgs.company_list =
								response.data.data.data_list;
							pageContext.searchArgs.company_id =
								pageContext.searchArgs.company_list[0].id;
							pageContext.pageSearchForm.setFieldsValue({
								company_id: pageContext.searchArgs.company_id,
							});
							pageContext.handleChangeCompany(
								pageContext.searchArgs.company_id
							);
						}

						pageContext.loadingSearchCompany = false;
					})
					.catch(function(error) {
						pageContext.loadingSearchCompany = false;
						console.log(error);
					});
			}
		},
		async handleChangeCompany(value) {
			pageContext.searchArgs.company_id = value;
			pageContext.tableDataList = [];
			pageContext.refreshDataList();
		},
		async refreshDataList() {
			let args = {};
			//平台
			if (pageContext.searchArgs.platform_type === "pl") {
				args = {
					platform_type: pageContext.searchArgs.platform_type,
				};
			}
			//药企、服务商
			else {
				args = {
					platform_type: pageContext.searchArgs.platform_type,
					company_id: pageContext.searchArgs.company_id,
				};
			}

			pageContext.$http
				.post("/ManagerMg/getDataList", args)
				.then(function(response) {
					if (
						response.data.status === 1 &&
						response.data.data.data_list.length > 0
					) {
						pageContext.tableDataList = response.data.data.data_list;
					}
				})
				.catch(function(error) {
					pageContext.$message.error("请求异常，请检查");
					console.log(error);
				});
		},
		addNew() {
			if (
				pageContext.searchArgs.platform_type !== "pl" &&
				pageContext.searchArgs.company_id === ""
			) {
				pageContext.$message.info("请选择：" + pageContext.company_label);
				return;
			}
			pageContext.$layer.iframe({
				content: {
					content: updatePanel,
					parent: this,
					data: {
						submitBtnLabel: "新 增",
						platform_type: pageContext.searchArgs.platform_type,
						company_id: pageContext.searchArgs.company_id,
					},
				},
				area: ["550px", "700px"],
				title: "新增管理员",
				shadeClose: false,
				cancel: () => {
					pageContext.$message.info("操作取消！");
				},
			});
		},
		handleEdit(record) {
			pageContext.$layer.iframe({
				content: {
					content: updatePanel,
					parent: this,
					data: {
						submitBtnLabel: "保 存",
						itemData: record,
					},
				},
				area: ["550px", "700px"],
				title: "修改管理员",
				shadeClose: false,
				cancel: () => {
					pageContext.$message.info("操作取消！");
				},
			});
		},
		bindAuthGroup(record) {
			pageContext.$layer.iframe({
				content: {
					content: authGroupPanel,
					parent: this,
					data: {
						itemData: record,
					},
				},
				area: ["650px", "600px"],
				title: "绑定用户角色",
				shadeClose: false,
				cancel: () => {
					pageContext.$message.info("操作取消！");
				},
			});
		},
		bindArea(record) {
			pageContext.$layer.iframe({
				content: {
					content: areaPanel,
					parent: this,
					data: {
						itemData: record,
					},
				},
				area: ["950px", "600px"],
				title: "绑定大区",
				shadeClose: false,
				cancel: () => {
					pageContext.$message.info("操作取消！");
				},
			});
		},
		async handleSetStatus(record, status) {
			pageContext.$http
				.post("/ManagerMg/setStatus", {
					id: record.id,
					status: status,
				})
				.then(function(response) {
					if (response.data.status === 1) {
						pageContext.$message.success(response.data.msg);
						pageContext.refreshDataList();
					}
				})
				.catch(function(error) {
					pageContext.$message.error("请求异常，请检查");
					console.log(error);
				});
		},
	},
};
</script>
<style lang="scss" scoped>
.client-container {
	.ant-btn-circle {
		margin: 0px 5px;
	}
}
</style>
